import { useRef } from 'react';
import { AiOutlineUpload } from 'react-icons/ai';

const UploadExcelButton = ({ onUpload }) => {
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && onUpload) {
            onUpload(file);
        }
        e.target.value = "";
    };

    return (
        <>
            <input
                type="file"
                accept=".xlsx, .xls"
                style={{ display: 'none' }}
                ref={fileInputRef}
                onChange={handleFileChange}
            />
            <button
                className="btn-excel-icon"
                onClick={() => fileInputRef.current.click()}
                title="Cargar Excel"
            >
                <AiOutlineUpload size={16} />
            </button>
        </>
    );
};

export default UploadExcelButton;
